<ion-card>
  <ion-icon
    margin-small
    pointer
    class="close icon-close"
    color="primary"
    name="close"
    size="large"
    (click)="closeModal()"
  ></ion-icon>
  <ion-card-header>
    <ion-card-title> Olá, {{ name }}! </ion-card-title>
  </ion-card-header>
  <ion-card-content>
    <h2> Passando para avisá-lo que o Group Check agora tem um novo nome! </h2>
    <br />
    <h3>
      A partir de julho, a marca do aplicativo passa a ser apresentada como <strong>Group Check</strong>.
    </h3>
    <br />
    <h3>
      Fique tranquilo, pois as funcionalidades, processos e usabilidade do aplicativo não tiveram mudanças,
      apenas o nome que passa a ser <strong>Group Check</strong>.
    </h3>
  </ion-card-content>
</ion-card>
